export const PERMISSION_DENIED_MESSAGE =
  'Você não tem permissão para acessar este serviço, verifique com o administrador';
const NETWORK_ERROR_MESSAGE = 'Não conseguimos acessar o servidor';
const NOT_FOUND_MESSAGE = 'Endereço não encontrado';
const DEFAULT_MESSAGE_500 = 'Falha no servidor, tente novamente mais tarde';
const DEFAULT_MESSAGE_400 = 'Requisição inválida';

const PARSE_ERROR = {
  errors: [
    {
      message: 'Erro ao interpretar resposta'
    }
  ],
  code: 0
};

const NETWORK_ERROR = {
  errors: [
    {
      message: NETWORK_ERROR_MESSAGE
    }
  ],
  code: -1
};

const RESPONSE_MESSAGES_BY_CODE = {
  400: DEFAULT_MESSAGE_400,
  403: PERMISSION_DENIED_MESSAGE,
  404: NOT_FOUND_MESSAGE,
  500: DEFAULT_MESSAGE_500,
  502: DEFAULT_MESSAGE_500,
  503: DEFAULT_MESSAGE_500,
  504: DEFAULT_MESSAGE_500
};

function looksLikeHtml(value) {
  if (typeof value !== 'string') return false;
  const trimmed = value.trim();
  return /^<!DOCTYPE\s+html/i.test(trimmed) || /^<html[\s>]/i.test(trimmed);
}

function toUserFacingErrorDetail(message) {
  if (!message || looksLikeHtml(message)) {
    return DEFAULT_MESSAGE_500;
  }
  return message;
}

function translateStatusCode(status, message = '') {
  if (RESPONSE_MESSAGES_BY_CODE[status]) {
    const messageError = RESPONSE_MESSAGES_BY_CODE[status];

    return {
      errors: [{ message: messageError }],
      code: status
    };
  }

  if (status === 401) {
    try {
      return { errors: [JSON.parse(message)], code: status };
    } catch {
      return { errors: [message], code: status };
    }
  }

  if (message) {
    try {
      const json = JSON.parse(message);
      const { errors } = json || {};

      if (errors === undefined) {
        const REMOVE_QUOTES = new RegExp(/('|")/g);
        const messageError = message.replace(REMOVE_QUOTES, '');
        return {
          errors: [{ message: toUserFacingErrorDetail(messageError) }],
          code: status
        };
      }

      return { errors, code: status };
    } catch {
      return {
        errors: [{ message: DEFAULT_MESSAGE_500 }],
        code: status
      };
    }
  }

  return { errors: [], code: 0 };
}

function asApiError(payload) {
  const message =
    payload?.errors?.[0]?.message || payload?.message || 'Request failed';
  const error = new Error(message);
  error.errors = payload.errors;
  error.code = payload.code;
  return error;
}

export {
  PARSE_ERROR,
  NETWORK_ERROR,
  translateStatusCode,
  toUserFacingErrorDetail,
  asApiError
};
